export const WeatherApiEndpoint = {
  fetchWeather: '/weathers/short/:date',
  fetchWeatherWeek: '/weathers/:date',
};
